var map = {
	"./3.jpeg": 7791,
	"./6.jpg": 1191,
	"./APARAT 079.jpg": 3515,
	"./APARAT 1030.jpg": 6076,
	"./APARAT 2098.jpg": 757,
	"./APARAT 712.jpg": 3928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4117;